import React from "react";
import { ShieldCheck, Leaf, Truck, Phone } from "lucide-react";

export default function GoldenPyroLanding() {
  return (
    <div className="font-sans bg-white text-gray-900 min-h-screen selection:bg-pink-300">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-pink-500 via-purple-500 to-indigo-500 text-center py-40 px-6 overflow-hidden flex flex-col items-center justify-center">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-white/20 via-transparent to-transparent pointer-events-none"></div>
        <div className="relative z-10 animate-fade-in-up">
          <h1 className="text-6xl md:text-8xl font-black text-white drop-shadow-[0_4px_12px_rgba(0,0,0,0.2)] tracking-tight">
            Golden Celebrations
          </h1>
          <p className="mt-8 text-xl md:text-2xl max-w-4xl mx-auto font-medium text-white/95 leading-relaxed drop-shadow-sm">
            Enjoy up to 90% OFF on premium festive essentials – Quality Celebration Packs at Factory Price!
          </p>
          <a
            // href="https://goldenpyrocrackers.com/price-list"
            className="mt-12 inline-block px-12 py-5 bg-white text-purple-600 text-xl rounded-full font-extrabold hover:bg-gray-50 transition-all duration-300 transform hover:-translate-y-2 hover:scale-105 shadow-[0_10px_30px_rgba(0,0,0,0.2)]"
          >
            Shop Now
          </a>
        </div>
        <div className="absolute inset-0 opacity-10 bg-[url('https://cdn-icons-png.flaticon.com/512/2917/2917995.png')] bg-cover bg-center mix-blend-overlay"></div>
      </section>

      {/* Highlight Offer */}
      <section className="py-24 bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 relative border-y border-indigo-100">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-white/60 to-transparent pointer-events-none"></div>
        <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
          <div className="inline-block px-8 pt-4 pb-1 rounded-full border border-purple-200 bg-white/70 mb-8 backdrop-blur-md shadow-sm">
            <h2 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600 pb-3 leading-tight">
              Mega Sale – Up to 90% OFF!
            </h2>
          </div>
          <p className="text-slate-700 text-xl md:text-2xl max-w-3xl mx-auto font-medium leading-relaxed">
            Buy direct festive collections at unbeatable prices. Safe packaging, doorstep delivery & exclusive festive combos.
          </p>
        </div>
      </section>

      {/* Feature Section - Modern Grid */}
      <section className="py-28 px-6 bg-white relative overflow-hidden">
        <div className="absolute -left-20 top-20 w-72 h-72 bg-pink-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 pointer-events-none"></div>
        <div className="absolute -right-20 bottom-20 w-72 h-72 bg-yellow-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 pointer-events-none"></div>

        <div className="relative z-10 grid md:grid-cols-3 gap-10 max-w-7xl mx-auto">
          {/* Trusted Brands */}
          <div className="group bg-white rounded-[2rem] p-10 hover:-translate-y-3 transition-all duration-500 text-center flex flex-col items-center shadow-[0_10px_40px_-10px_rgba(239,68,68,0.2)] border border-red-50 hover:shadow-[0_20px_50px_-10px_rgba(239,68,68,0.3)]">
            <div className="w-24 h-24 rounded-full bg-red-50 flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-500">
              <ShieldCheck className="w-12 h-12 text-red-500" strokeWidth={2} aria-hidden="true" />
            </div>
            <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-4 group-hover:text-red-500 transition-colors">Trusted Brands</h3>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed">
              Authentic festive items, ensuring quality and joyful celebrations.
            </p>
          </div>

          {/* Eco-Friendly */}
          <div className="group bg-white rounded-[2rem] p-10 hover:-translate-y-3 transition-all duration-500 text-center flex flex-col items-center shadow-[0_10px_40px_-10px_rgba(34,197,94,0.2)] border border-green-50 hover:shadow-[0_20px_50px_-10px_rgba(34,197,94,0.3)]">
            <div className="w-24 h-24 rounded-full bg-green-50 flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-500">
              <Leaf className="w-12 h-12 text-green-500" strokeWidth={2} aria-hidden="true" />
            </div>
            <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-4 group-hover:text-green-500 transition-colors">Eco-Friendly</h3>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed">
              Wide range of eco-friendly, low-impact festive essentials for sustainable celebrations.
            </p>
          </div>

          {/* Safe Delivery */}
          <div className="group bg-white rounded-[2rem] p-10 hover:-translate-y-3 transition-all duration-500 text-center flex flex-col items-center shadow-[0_10px_40px_-10px_rgba(234,179,8,0.2)] border border-yellow-50 hover:shadow-[0_20px_50px_-10px_rgba(234,179,8,0.3)]">
            <div className="w-24 h-24 rounded-full bg-yellow-50 flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-500">
              <Truck className="w-12 h-12 text-yellow-500" strokeWidth={2} aria-hidden="true" />
            </div>
            <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-4 group-hover:text-yellow-500 transition-colors">Safe Delivery</h3>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed">
              Waterproof, shock-proof packaging with reliable logistics for on-time delivery.
            </p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section
        id="shop"
        className="relative py-32 text-center px-4 overflow-hidden bg-gradient-to-r from-emerald-400 via-teal-400 to-cyan-400"
      >
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom,_var(--tw-gradient-stops))] from-white/20 via-transparent to-transparent pointer-events-none"></div>
        <div className="relative z-10 max-w-4xl mx-auto bg-white/20 backdrop-blur-md rounded-3xl p-12 border border-white/30 shadow-2xl">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6 text-white drop-shadow-sm">
            Order Direct from Our Celebration Outlet
          </h2>
          <p className="text-teal-50 text-xl md:text-2xl mx-auto mb-10 leading-relaxed font-medium">
            Celebrate with authentic festive collections at factory-direct rates. Grab your celebration packs early for the best offers!
          </p>
          <a
            // href="https://goldenpyrocrackers.com/price-list"
            className="inline-block px-12 py-5 bg-white text-teal-600 text-xl rounded-full font-extrabold hover:bg-teal-50 transition-all duration-300 transform hover:scale-105 hover:-translate-y-1 shadow-[0_10px_20px_rgba(0,0,0,0.1)]"
          >
            Order Now
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer
        id="contact"
        className="bg-slate-900 py-24 text-center px-4 relative overflow-hidden"
      >
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom,_var(--tw-gradient-stops))] from-blue-900/40 via-slate-900 to-slate-900"></div>
        <div className="relative z-10">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-6 text-white tracking-wide">
            Golden Celebrations
          </h2>
          <p className="text-slate-300 text-base md:text-lg max-w-xl mx-auto mb-2 font-medium">
            Celebration Outlet, Main Road, Amathur - 626005
          </p>
          <p className="text-emerald-400 text-lg md:text-xl font-bold tracking-widest mb-10">Ph: 7418878751</p>
          <div>
            <a
              // href="https://goldenpyrocrackers.com/price-list"
              className="inline-block px-10 py-4 bg-gradient-to-r from-pink-500 to-rose-500 text-white text-base md:text-lg font-bold rounded-full shadow-lg transition-all duration-300 hover:shadow-[0_0_20px_rgba(244,63,94,0.4)] hover:-translate-y-1"
            >
              Shop Now
            </a>
          </div>
        </div>
      </footer>

      {/* Floating Action Buttons */}
      <div className="fixed bottom-8 left-8 flex flex-col gap-4 z-50">
        {/* Call Floating Icon */}
        <a
          href="tel:7418878751"
          className="bg-blue-500 p-4 rounded-full shadow-[0_10px_30px_rgba(59,130,246,0.4)] hover:shadow-[0_15px_40px_rgba(59,130,246,0.6)] hover:scale-110 transition-all duration-300 flex items-center justify-center group border-4 border-white"
          title="Call Us"
        >
          <Phone className="w-8 h-8 text-white group-hover:rotate-12 transition-transform" fill="currentColor" />
        </a>

        {/* WhatsApp Floating Icon */}
        <a
          href="https://wa.me/917418878751"
          className="bg-[#25D366] p-4 rounded-full shadow-[0_10px_30px_rgba(37,211,102,0.4)] hover:shadow-[0_15px_40px_rgba(37,211,102,0.6)] hover:scale-110 transition-all duration-300 flex items-center justify-center group border-4 border-white"
          title="WhatsApp Us"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="WhatsApp"
            className="w-9 h-9 group-hover:rotate-12 transition-transform"
          />
        </a>
      </div>
    </div>
  );
}
